import { render, staticRenderFns } from "./InventoryPageItems.vue?vue&type=template&id=3c05d4fa"
import script from "./InventoryPageItems.vue?vue&type=script&lang=js"
export * from "./InventoryPageItems.vue?vue&type=script&lang=js"
import style0 from "./InventoryPageItems.vue?vue&type=style&index=0&id=3c05d4fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports